import { render, staticRenderFns } from "./GoingDigital.vue?vue&type=template&id=3fd8dd56&"
import script from "./GoingDigital.vue?vue&type=script&lang=js&"
export * from "./GoingDigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports